import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { PostnummerServicePartnerEntity } from 'src/app/api/models/OK/Egis/Service/Models/Entities/postnummer-service-partner-entity';

@Component({
    selector: 'app-partner-input',
    templateUrl: './partner-input.component.html',
    styleUrls: ['./partner-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerInputComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() produktId: ProduktEnum;
  @Input() partners: PostnummerServicePartnerEntity[];

  @Output() selectedPartner = new EventEmitter<PostnummerServicePartnerEntity>();

  unsubscribe$ = new Subject<void>();

  partnerCtrl = new UntypedFormControl(null, Validators.required);

  get partnerNo() {
    return this.form.get('partnerNo');
  }

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  partnerSelected(partner: PostnummerServicePartnerEntity) {
    this.partnerNo.patchValue(partner.partner.partnerNo);
    this.selectedPartner.emit(partner);
  }
}
